import React, { useState, useEffect, useRef } from "react";
import { Form, Button, Container, Row, Col, Card } from "react-bootstrap";
import "./Security.css";
import user from "../../../images/user.jpg";
import CheckInimg from "../../../images/CheckInimg.png";
import { useForm } from "react-hook-form";
import axios from "../../util/Axios/AxiosInstance";
import { FiLogOut, FiLogIn } from "react-icons/fi";
import Modal from "react-bootstrap/Modal";
import Skeleton from "react-loading-skeleton";
import AOS from "aos";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "aos/dist/aos.css";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { error } from "jquery";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Security() {

    // Helper function to format date with leading zeros
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Helper function to format datetime with leading zeros
    const formatDateTime = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const manpowerType = [
        {key : 'Fixed', value : "Fixed"},
        {key : 'Casual', value : "Casual"},
    ]

    const onSelectManPowerType = (e) => {
        console.log(e.target.value);
        if(e.target.value === "Fixed"){
            setShowShift(true);
            getFixedManPowerType();
        }
        else{
            getShiftDetails();
        }
    }

    const getFixedManPowerType = () => {
        console.log("getFixedManPowerTypeAPI ------------------------");
    }

    const {
        register, formState: {errors},
    } = useForm();
    const onSubmit = (data) => {
    };
    const [showShift,setShowShift] = useState(true);
    const [show, setShow] = useState(false);
    const [showMsgI, setShowMsgI] = useState("");
    const [showMsgO, setShowMsgO] = useState("");
    const [showCO, setShowCO] = useState("");
    const handleClose = () => {
        setShow(false);
        setShowMsgI('');
        setShowMsgO('');
        setShowCO(prevState => prevState == true ? "" : prevState);
    };
    const handleShow = (e) => {
        e.preventDefault();
        setShow(true);
    };
    //     const showSuccessMsgI = () => setShowMsgI(true);
    //     const showSuccessMsgO = () => setShowMsgO(true);
    const showCheckOut = () => setShowCO(true);

    const checkOutBtn = (e) => {
        e.preventDefault();
        handleShow(e);
        showCheckOut();
    };

    const [showEmpDetails, setShowEmpDetails] = React.useState(false);
    // const onClickEmpName =  (empList.laborerId) => setShowEmpDetails(true);
    const [deptId, setDeptId] = useState("");
    const [subDeptId, setSubDeptId] = useState("");
    const [deptName, setDeptName] = useState("");
    const [subDeptName, setSubDeptName] = useState("");
    const [branchId, setBranchId] = useState("");
    const [transactionDate, setTransactionDate] = useState("");
    const [clTransactionId, setClTransactionId] = useState("");
    //   const [transactionId, setTransactionId] = useState('')
    const [dataListNew, setDataListNew] = useState({deptId:'', deptName:'', subDeptId:'', subDeptName:''});
    // const [updatedDeptId, setUpdatedDeptId] = useState("");
    // const [updatedDeptName, setUpdatedDeptName] = useState("");
    // const [updatedSubDeptId, setUpdatedSubDeptId] = useState("");
    // const [updatedSubDeptName, setUpdatedSubDeptName] = useState("");

    const labId = useRef("");
    const onClickEmpName = (dataList) => {
        // console.log(dataList);
        setDataListNew(dataList);

        //     setLaborerId(dataList.labourId);
        labId.current = dataList.labourId;
        setClTransactionId(dataList.clTransactionId);

        setLaborerName(dataList.labourerName);
        setVendorId(dataList.vendorId);

        setVendorName(dataList.vendorName);
        setShiftId(dataList.shiftId);

        setShiftName(dataList.shiftName);
        setTransactionDate(dataList.currentdate);
        var currentdate = new Date();
        var datetime = formatDate(currentdate);
        setDeptId(dataList.deptId);
        setSubDeptId(dataList.subDeptId);
        setDeptName(dataList.deptName);
        setSubDeptName(dataList.subDeptName);
        setBranchId(dataList.branchId);

        // Check if this labourer has a saved department assignment
        const savedAssignment = labourerDeptAssignments[dataList.labourId];
        if (savedAssignment) {
            setDeptId(savedAssignment.deptId);
            setDeptName(savedAssignment.deptName);
            // Update dataListNew with saved assignment
            dataList.deptId = savedAssignment.deptId;
            dataList.deptName = savedAssignment.deptName;
        }

        setShowEmpDetails(true);
        setSecurityCheckIn("");
        setSecurityCheckOut("");
        setDeptartmentCheckOut("");
        // Reset editing state when new labourer is selected
        setShowDeptDrop(false);
        setEditingLabourId(null);
        setDeptUpdated(false);
        getCheckInCheckOutDetails(datetime, labId.current);
        // statusCheck();

        // getCheckCheckIn(datetime, labId.current);
        // getCheckCheckOut(datetime, labId.current);
        // getDeptCheckOut(datetime, labId.current);
    };


    const[securityCheckIn, setSecurityCheckIn] = useState("");
    const[securityCheckOut, setSecurityCheckOut] = useState("");
    const[departmentCheckIn, setDepartmentCheckIn] = useState("");
    const[deptartmentCheckOut,setDeptartmentCheckOut] = useState("");
    const[statusCount, setStatusCount] = useState(0);

    const statusCheck = () => {
        if(securityCheckOut === true){
            setStatusCount(4);
            return;
        }
        else if(deptartmentCheckOut === true){
            setStatusCount(3);
            return;

        }
        else if(departmentCheckIn === true){
            setStatusCount(2);
            return;

        }
        else if(securityCheckIn === true){
            setStatusCount(1);
            return;

        }
        else{
            setStatusCount(0);
            return;

        }
    };

    const stepStyleConfig = {
        activeBgColor: '#5dbbff',
        activeTextColor: '#000000',
        completedBgColor: '#32CD32',
        completedTextColor: '#000000',
        inactiveTextColor : '#000000',
    };


    const [vendorMasterData, setVendorMasterData] = useState([]);
    const [detailsForSecurityVendorId, setDetailsForSecurityVendorId] = useState([]);
    const [detailsForSecurityByShiftId, setDetailsForSecurityByShiftId] = useState([]);
    const [masterLabourerDetailsByTransactionDate, setMasterLabourerDetailsByTransactionDate,] = useState([{
        labourerName: <Skeleton/>
    }, {labourerName: <Skeleton/>}, {labourerName: <Skeleton/>}, {labourerName: <Skeleton/>}, {
        labourerName: <Skeleton/>
    }, {labourerName: <Skeleton/>},]);
    const [securityTransactionDetailsByTransactionDate, setSecurityTransactionDetailsByTransactionDate,] = useState([{}]);
    const [checkCheckIn, setCheckCheckIn] = useState([]);
    const [checkCheckOut, setCheckCheckOut] = useState([]);
    const [deptCheckOut, setDeptCheckOut] = useState([{}]);
    const [entryType, setEntryType] = useState("");
    const [shiftId, setShiftId] = useState("");
    const [shiftName, setShiftName] = useState("");
    //const [counter, setCounter] = useState('');
    const [newArray, setNewArray] = useState([]);
    const [checkIn, setCheckIn] = useState(0);
    const [checkOut, setCheckOut] = useState(0);
    const [shiftData, setShiftData] = useState([]);
    const [laborerId, setLaborerId] = useState("");
    const [laborerName, setLaborerName] = useState("");
    const [vendorId, setVendorId] = useState("");
    const [vendorName, setVendorName] = useState("");
    // const [vendorTransactionMaster, setVendorTransactionMaster] = useState([]);
    // const [vendorTransactionDetails, setVendorTransactionDetails] = useState([]);
    const [securityCheckAdd, setSecurityCheckAdd] = useState([]);
    const FilterArray = useRef([]);
    const shiftIDRef = useRef("");

    const [showCheckIn, setShowCheckIn] = useState(false);
    const [showChckOut, setShowChckOut] = useState(false);
    const [showDeptDrop, setShowDeptDrop] = useState(false);
    // const [counterIn, setCounterIn] = useState(0);
    // const [counterOut, setCounterOut] = useState(0);
    const [deptDrop,setDeptDrop] = useState([]);
    const [subDeptDrop,setSubDeptDrop] = useState([]);
    const [deptUpdated, setDeptUpdated] = useState(false);
    const [deptSubDeptUpdated, setDeptSubDeptUpdated] = useState(false);
    const [editingLabourId, setEditingLabourId] = useState(null);
    const [tempDeptId, setTempDeptId] = useState("");
    const [tempDeptName, setTempDeptName] = useState("");
    const [labourerDeptAssignments, setLabourerDeptAssignments] = useState({});
    // Add new state for multiple selection
    const [selectedLabourers, setSelectedLabourers] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [selectedLabourersCheckOut, setSelectedLabourersCheckOut] = useState([]);
    const [selectAllCheckOut, setSelectAllCheckOut] = useState(false);

    // Add loading states for buttons
    const [isBulkCheckInLoading, setIsBulkCheckInLoading] = useState(false);
    const [isBulkCheckOutLoading, setIsBulkCheckOutLoading] = useState(false);
    const [isIndividualCheckInLoading, setIsIndividualCheckInLoading] = useState(false);
    const [isIndividualCheckOutLoading, setIsIndividualCheckOutLoading] = useState(false);


    useEffect(() => {
        AOS.init();
        //      getVendorMasterDetails();
        const branchId = localStorage.getItem("branchId");
        // getMasterLabourerDetailsByTransactionDateAndBranchId(branchId);
        getSecurityTransactionDetailsByTransactionDate(branchId);
        getDepartmentDetails(branchId);
        getShiftDetails();
        getLabourersForCheckOut(branchId);
    }, [deptUpdated]);

    useEffect(() => {
        // const checkInCount = securityTransactionDetailsByTransactionDate.filter((data) => data.entryType == "CheckIn");
        // const checkOutCount = securityTransactionDetailsByTransactionDate.filter((data) => data.entryType == "CheckOut");

        //
        // setCounterIn(securityTransactionDetailsByTransactionDate[0].checkinCount);
        // setCounterOut(securityTransactionDetailsByTransactionDate[0].checkoutcount);

        // Reset select all states when labour list changes
        setSelectAll(false);
        setSelectAllCheckOut(false);
        setSelectedLabourers([]);
        setSelectedLabourersCheckOut([]);
    }, [ masterLabourerDetailsByTransactionDate, newArray, dataListNew,]);
    useEffect(() => {
    }, [transactionDate, checkCheckIn, checkCheckOut, deptCheckOut]);
    useEffect(() => {
        //
        //       getCheckCheckIn(transactionDate,laborerId);
    }, [laborerId]);

    useEffect(() => {
        // statusCheck();
    },[securityCheckIn,securityCheckOut,departmentCheckIn,deptartmentCheckOut,statusCount]);

    useEffect(() => {

    },[statusCount]);

    const getDepartmentDetails = (branchId) => {
        axios
            .get("getDepartmentDetailsbyBranchID/" + branchId)
            .then((data) => {
                if (data.status === 200) {
                    const newData = data.data;
                    setDeptDrop(newData);
                } else {
                    // window.location.href = "/error"
                }
            })
            .catch((error) => {
                console.error(error);

                // window.location.href = "/error"
            });
    };

    const getSubDepartmentDetailsbyDeptID = (deptId) => {
        setSubDeptDrop([]);
        axios
            .get("getSubDepartmentDetailsbyDeptID/" + deptId)
            .then((data) => {
                if (data.status === 200) {
                    const newData = data.data;
                    setSubDeptDrop(newData);
                } else {
                    // window.location.href = "/error"
                }
            })
            .catch((error) => {
                console.error(error);

                // window.location.href = "/error"
            });
    };

    const editLabourDept = (e) => {
        e.preventDefault();
        console.log(e.target.value);
        console.log(e.target.selectedOptions[0].id);
        setTempDeptId(e.target.value);
        setTempDeptName(e.target.selectedOptions[0].id);
        setDeptUpdated(true);
        // setUpdatedDeptId(e.target.value);
        // setUpdatedDeptName(e.target.selectedOptions[0].id);
        getSubDepartmentDetailsbyDeptID(e.target.value);
    }

    const editLabourSubD = (e) => {
        e.preventDefault();
        console.log(e.target.value);
        console.log(e.target.selectedOptions[0].id);
        setSubDeptId(e.target.value);
        setSubDeptName(e.target.selectedOptions[0].id);
        setDeptSubDeptUpdated(true);
        // setUpdatedSubDeptId(e.target.value);
        // setUpdatedSubDeptName(e.target.selectedOptions[0].id);
    }

    const saveLabourDeptAndSubD = (e) => {
        // Save the department assignment for this specific labourer
        const labourId = dataListNew.labourId;
        setLabourerDeptAssignments(prev => ({
            ...prev,
            [labourId]: {
                deptId: tempDeptId,
                deptName: tempDeptName
            }
        }));

        // Update the current display
        setDataListNew({...dataListNew,
            deptId : tempDeptId,
            deptName : tempDeptName,
            subDeptId : '', // Reset subdepartment
            subDeptName : '' // Reset subdepartment name
        });

        setShowDeptDrop(false);
        setDeptUpdated(true);
        setEditingLabourId(null);
        // Update the global state as well
        setDeptId(tempDeptId);
        setDeptName(tempDeptName);

        toast.success("Department assignment saved for this labourer");
    }

    const handleDeptEditClick = (labourId) => {
        setEditingLabourId(labourId);
        setShowDeptDrop(!showDeptDrop);
        // Load departments when edit is clicked
        getDepartmentDetails(branchId);
        // Reset temp values
        setTempDeptId(dataListNew.deptId || "");
        setTempDeptName(dataListNew.deptName || "");
    }

    // Function to clear all department assignments
    const clearAllDeptAssignments = () => {
        setLabourerDeptAssignments({});
        toast.info("All department assignments cleared");
    }

    // Add new functions for multiple selection
    const handleSelectAll = (e) => {
        const isChecked = e.target.checked;
        setSelectAll(isChecked);

        if (isChecked) {
            const currentLabourers = shiftIDRef.current === ""
                ? masterLabourerDetailsByTransactionDate
                : newArray;
            setSelectedLabourers(currentLabourers.map(lab => lab.labourId));
        } else {
            setSelectedLabourers([]);
        }
    };

    const handleSelectAllCheckOut = (e) => {
        const isChecked = e.target.checked;
        setSelectAllCheckOut(isChecked);

        if (isChecked) {
            const currentLabourers = shiftIDRef.current === ""
                ? checkOutLabourers
                : checkOutLabourersByShift;
            setSelectedLabourersCheckOut(currentLabourers.map(lab => lab.labourId));
        } else {
            setSelectedLabourersCheckOut([]);
        }
    };

    const handleSelectLabourer = (labourId) => {
        setSelectedLabourers(prev => {
            if (prev.includes(labourId)) {
                return prev.filter(id => id !== labourId);
            } else {
                return [...prev, labourId];
            }
        });
    };

    const handleSelectLabourerCheckOut = (labourId) => {
        setSelectedLabourersCheckOut(prev => {
            if (prev.includes(labourId)) {
                return prev.filter(id => id !== labourId);
            } else {
                return [...prev, labourId];
            }
        });
    };

    const handleBulkCheckIn = async (e) => {
        e.preventDefault();
        if (selectedLabourers.length === 0) {
            toast.warning("Please select at least one labourer");
            return;
        }

        if (isBulkCheckInLoading) return; // Prevent multiple clicks

        setIsBulkCheckInLoading(true);
        const userName = localStorage.getItem("username");
        const promises = selectedLabourers.map(labourId => {
            const labourer = (shiftIDRef.current === ""
                ? masterLabourerDetailsByTransactionDate
                : newArray).find(lab => lab.labourId === labourId);

            if (!labourer) return Promise.resolve();

            var currentdate = new Date();
            var datetime = formatDate(currentdate);
            var datetime1 = formatDateTime(currentdate);

            // Check if this labourer has a saved department assignment
            const savedAssignment = labourerDeptAssignments[labourId];
            const deptId = savedAssignment ? savedAssignment.deptId : labourer.deptId;
            const deptName = savedAssignment ? savedAssignment.deptName : labourer.deptName;

            const deptVendorDataAdd1 = {
                vendorId: labourer.vendorId,
                vendorCLTransactionId: labourer.clTransactionId,
                transactionDate: datetime,
                subDepartmentId: labourer.subDeptId,
                departmentId: deptId,
                labourId: labourId,
                entryType: "CheckIn",
                shiftId: labourer.shiftId,
                shiftName: labourer.shiftName,
                createdBy: userName,
                createdDate: datetime1,
                branchId: labourer.branchId,
            };

            return axios.post("addSecurityTransactionDetails", deptVendorDataAdd1);
        });

        try {
            await Promise.all(promises);
            setShowMsgI(true);
            setCheckIn(checkIn + selectedLabourers.length);
            setSelectedLabourers([]);
            setSelectAll(false);
            // Refresh the data
            const branchId = localStorage.getItem("branchId");
            getSecurityTransactionDetailsByTransactionDate(branchId);
            getLabourersForCheckOut(branchId); // Refresh checkout data
            if (shiftIDRef.current !== "") {
                getLabourersForCheckOutByShift(branchId, shiftIDRef.current); // Refresh checkout data by shift
            }
            toast.success(`Successfully checked in ${selectedLabourers.length} labourer(s)`);
            handleShow(e);
        } catch (error) {
            console.error("Bulk check-in failed:", error);
            toast.error("Some check-ins failed. Please try again.");
        } finally {
            setIsBulkCheckInLoading(false);
        }
    };

    const handleBulkCheckOut = async (e) => {
        e.preventDefault();
        if (selectedLabourersCheckOut.length === 0) {
            toast.warning("Please select at least one labourer");
            return;
        }

        if (isBulkCheckOutLoading) return; // Prevent multiple clicks

        setIsBulkCheckOutLoading(true);
        const userName = localStorage.getItem("username");
        const promises = selectedLabourersCheckOut.map(labourId => {
            const labourer = (shiftIDRef.current === ""
                ? checkOutLabourers
                : checkOutLabourersByShift).find(lab => lab.labourId === labourId);

            if (!labourer) return Promise.resolve();

            var currentdate = new Date();
            var datetime = formatDate(currentdate);
            var datetime1 = formatDateTime(currentdate);

            const deptVendorDataAdd2 = {
                vendorId: labourer.vendorId,
                vendorCLTransactionId: labourer.clTransactionId,
                transactionDate: datetime,
                subDepartmentId: labourer.subDeptId,
                departmentId: labourer.deptId,
                labourId: labourId,
                entryType: "CheckOut",
                shiftId: labourer.shiftId,
                shiftName: labourer.shiftName,
                createdBy: userName,
                createdDate: datetime1,
                branchId: labourer.branchId,
            };

            return axios.post("addSecurityTransactionDetails", deptVendorDataAdd2);
        });

        try {
            await Promise.all(promises);
            setShowMsgO(true);
            setCheckOut(checkOut + selectedLabourersCheckOut.length);
            setSelectedLabourersCheckOut([]);
            setSelectAllCheckOut(false);
            // Refresh the data
            const branchId = localStorage.getItem("branchId");
            getSecurityTransactionDetailsByTransactionDate(branchId);
            getLabourersForCheckOut(branchId); // Refresh checkout data
            if (shiftIDRef.current !== "") {
                getLabourersForCheckOutByShift(branchId, shiftIDRef.current); // Refresh checkout data by shift
            }
            toast.success(`Successfully checked out ${selectedLabourersCheckOut.length} labourer(s)`);
            checkOutBtn(e);
        } catch (error) {
            console.error("Bulk check-out failed:", error);
            toast.error("Some check-outs failed. Please try again.");
        } finally {
            setIsBulkCheckOutLoading(false);
        }
    };

    // Helper function to render labour list with checkboxes for Check In
    const renderLabourListCheckIn = (labourList) => (
        <Card className="CardScroll">
            <div className="bulk-actions mb-2 p-2" style={{
                backgroundColor: '#f8f9fa',
                borderBottom: '1px solid #dee2e6',
                borderRadius: '4px 4px 0 0'
            }}>
                <div className="d-flex justify-content-between align-items-center">
                    <Form.Check
                        type="checkbox"
                        label={<strong>Select All ({labourList.length})</strong>}
                        checked={selectAll}
                        onChange={handleSelectAll}
                    />
                    {selectedLabourers.length > 0 && (
                        <span className="badge bg-primary">{selectedLabourers.length} selected</span>
                    )}
                </div>
                {selectedLabourers.length > 0 && (
                    <div className="mt-2">
                        <Button
                            size="sm"
                            variant="success"
                            onClick={handleBulkCheckIn}
                            className="me-2"
                            disabled={isBulkCheckInLoading}
                        >
                            <FiLogIn className="me-1" />
                            {isBulkCheckInLoading ? "Processing..." : `Bulk Check In (${selectedLabourers.length})`}
                        </Button>
                    </div>
                )}
            </div>
            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                {labourList.map((dataList) => (
                    <Row key={dataList.labourId} className="mt-2 align-items-center p-2" style={{
                        backgroundColor: selectedLabourers.includes(dataList.labourId) ? '#e8f5e8' : 'transparent',
                        borderBottom: '1px solid #f0f0f0',
                        transition: 'background-color 0.2s'
                    }}>
                        <Col xs={2}>
                            <Form.Check
                                type="checkbox"
                                checked={selectedLabourers.includes(dataList.labourId)}
                                onChange={() => handleSelectLabourer(dataList.labourId)}
                            />
                        </Col>
                        <Col xs={10}>
                            <p
                                className="info1 mb-0"
                                onClick={(e) => onClickEmpName(dataList)}
                                style={{ cursor: 'pointer', transition: 'background-color 0.2s' }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#e9ecef'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                            >
                                {dataList.labourerName}
                            </p>
                        </Col>
                    </Row>
                ))}
            </div>
        </Card>
    );

    // Helper function to render labour list with checkboxes for Check Out
    const renderLabourListCheckOut = (labourList) => (
        <Card className="CardScroll">
            <div className="bulk-actions mb-2 p-2" style={{
                backgroundColor: '#f8f9fa',
                borderBottom: '1px solid #dee2e6',
                borderRadius: '4px 4px 0 0'
            }}>
                <div className="d-flex justify-content-between align-items-center">
                    <Form.Check
                        type="checkbox"
                        label={<strong>Select All ({labourList.length})</strong>}
                        checked={selectAllCheckOut}
                        onChange={handleSelectAllCheckOut}
                    />
                    {selectedLabourersCheckOut.length > 0 && (
                        <span className="badge bg-warning text-dark">{selectedLabourersCheckOut.length} selected</span>
                    )}
                </div>
                {selectedLabourersCheckOut.length > 0 && (
                    <div className="mt-2">
                        <Button
                            size="sm"
                            variant="warning"
                            onClick={handleBulkCheckOut}
                            disabled={isBulkCheckOutLoading}
                        >
                            <FiLogOut className="me-1" />
                            {isBulkCheckOutLoading ? "Processing..." : `Bulk Check Out (${selectedLabourersCheckOut.length})`}
                        </Button>
                    </div>
                )}
            </div>
            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                {labourList.map((dataList) => (
                    <Row key={dataList.labourId} className="mt-2 align-items-center p-2" style={{
                        backgroundColor: selectedLabourersCheckOut.includes(dataList.labourId) ? '#fff3cd' : 'transparent',
                        borderBottom: '1px solid #f0f0f0',
                        transition: 'background-color 0.2s'
                    }}>
                        <Col xs={2}>
                            <Form.Check
                                type="checkbox"
                                checked={selectedLabourersCheckOut.includes(dataList.labourId)}
                                onChange={() => handleSelectLabourerCheckOut(dataList.labourId)}
                            />
                        </Col>
                        <Col xs={10}>
                            <p
                                className="info1 mb-0"
                                onClick={(e) => onClickEmpName(dataList)}
                                style={{ cursor: 'pointer', transition: 'background-color 0.2s' }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#e9ecef'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                            >
                                {dataList.labourerName}
                            </p>
                        </Col>
                    </Row>
                ))}
            </div>
        </Card>
    );

    // Add state for checkout labourers
    const [checkOutLabourers, setCheckOutLabourers] = useState([]);
    const [checkOutLabourersByShift, setCheckOutLabourersByShift] = useState([]);

    // Function to get labourers who are checked in but not checked out
    const getLabourersForCheckOut = (branchId) => {
        var currentdate = new Date();
        var transactionDate = formatDate(currentdate);
        axios
            .get("getLabourersCheckedInButNotCheckedOut/" + transactionDate + "/" + branchId)
            .then((data) => {
                if (data.status === 200) {
                    const getData = data.data;
                    setCheckOutLabourers(getData);
                } else {
                    setCheckOutLabourers([]);
                }
            })
            .catch((error) => {
                console.error(error);
                setCheckOutLabourers([]);
            });
    };

    // Function to get labourers for checkout by shift
    const getLabourersForCheckOutByShift = (branchId, shiftId) => {
        var currentdate = new Date();
        var transactionDate = formatDate(currentdate);
        axios
            .get("getLabourersCheckedInButNotCheckedOutByShift/" + transactionDate + "/" + branchId + "/" + shiftId)
            .then((data) => {
                if (data.status === 200) {
                    const getData = data.data;
                    setCheckOutLabourersByShift(getData);
                } else {
                    setCheckOutLabourersByShift([]);
                }
            })
            .catch((error) => {
                console.error(error);
                setCheckOutLabourersByShift([]);
            });
    };

    const getShiftDetails = () => {
        axios
            .get("getShiftDetails")
            .then((data) => {
                if (data.status === 200) {
                    const shiftData1 = data.data;
                    setShiftData(shiftData1);
                    setShowShift(false);
                } else {
                }
            })
            .catch((error) => {
                // console.error(error);
            });
    };

    const getVendorMasterDetails = () => {
        axios
            .get("getVendorMasterDetails")
            .then((data) => {
                if (data.status === 200) {
                    const vendorMasterData = data.data;
                    setVendorMasterData(vendorMasterData);
                } else {
                    // window.location.href = "/error"
                }
            })
            .catch((error) => {
                console.error(error);

                // window.location.href = "/error"
            });
    };

    const getMasterLabourerDetailsByTransactionDateAndBranchId = (branchId) => {
        var currentdate = new Date();
        // var transactionDate = '2023-02-23 00:00:00';
        var transactionDate = formatDate(currentdate);
        console.log("Calling API with transactionDate:", transactionDate);
        axios
            .get("getLabourersNotCheckedIn/" + transactionDate + "/" + branchId)
            .then((data) => {
                if (data.status === 200) {
                    const getData = data.data;
                    setMasterLabourerDetailsByTransactionDate(getData);
                    console.log("API response:", getData);
                } else {
                    console.error("API returned non-200 status:", data.status);
                }
            })
            .catch((error) => {
                console.error("API call failed:", error);
                console.error("Error details:", error.response?.data);
                setMasterLabourerDetailsByTransactionDate([]);
            });
    };

    const getSecurityTransactionDetailsByTransactionDate = (branchId) => {
        //
        var currentdate = new Date();
        // var transactionDate = '2023-02-23 00:00:00';
        var transactionDate = formatDate(currentdate);
        axios
            .get("getSecTransactionDetailsByTransactionDateAndBranchId/" + transactionDate + "/" + branchId)
            .then((data) => {
                if (data.status === 200) {
                    const getData = data.data;
                    // setSecurityTransactionDetailsByTransactionDate(getData);
                    setCheckIn(getData[0].checkinCount);
                    setCheckOut(getData[0].checkoutcount);
                } else {
                }
            })
            .catch((error) => {
                // console.error(error);
            });
        getMasterLabourerDetailsByTransactionDateAndBranchId(branchId);
    };

    const getCheckInCheckOutDetails = (transactionDate, labourId) => {
        var currentdate = new Date();
        var transactionDate = formatDate(currentdate);
        axios
            .get("getCheckInCheckOutDetails/" + transactionDate + "/" + labourId)
            .then((data) => {
                if (data.status === 200) {
                    // setSecurityCheckIn(data.data[0].securityCheckIn);
                    // setSecurityCheckOut(data.data[0].securityCheckOut);
                    // setDepartmentCheckOut(data.data[0].deptCheckOut);
                    setSecurityCheckIn(data.data[0].securityCheckIn);
                    setSecurityCheckOut(data.data[0].securityCheckOut);
                    setDepartmentCheckIn(data.data[0].deptCheckIn);
                    setDeptartmentCheckOut(data.data[0].deptCheckOut);
                    // setCheckCheckIn(data.data);
                } else {
                }
            })
            .catch((error) => {
                // console.error(error);
            });
    };

    const getCheckCheckIn = (transactionDate, labourId) => {
        var currentdate = new Date();
        // var transactionDate = '2023-02-23 00:00:00';
        var transactionDate = formatDate(currentdate);
        //labourId = labourId;
        axios
            .get("getSecurityTransactionDetailsCheckIn/CheckIn/" + transactionDate + "/" + labourId)
            .then((data) => {
                if (data.status === 200) {
                    setCheckCheckIn(data.data);
                    if (data.data.length > 0) {
                        setShowCheckIn(false);
                    } else {
                        setShowCheckIn(true);
                    }
                } else {
                }
            })
            .catch((error) => {
                // console.error(error);
            });
    };
    const getCheckCheckOut = (transactionDate, labourId) => {
        var currentdate = new Date();
        // var transactionDate = '2023-02-23 00:00:00';
        var transactionDate = formatDate(currentdate);
        //labourId = labourId;
        axios
            .get("getSecurityTransactionDetailsCheckIn/CheckOut/" + transactionDate + "/" + labourId)
            .then((data) => {
                if (data.status === 200) {
                    setCheckCheckOut(data.data);
                    if (data.data.length > 0) {
                        setShowChckOut(false);
                    } else {
                        setShowChckOut(true);
                    }
                } else {
                }
            })
            .catch((error) => {
                // console.error(error);
            });
    };

    const getDeptCheckOut = (transactionDate, labourId) => {
        var currentdate = new Date();
        // var transactionDate = '2023-02-23 00:00:00';
        var transactionDate = formatDate(currentdate);
        //labourId = labourId;
        axios
            .get("getDeptTransactionDetailsCheckOut/CheckOut/" + transactionDate + "/" + labourId)
            .then((data) => {
                if (data.status === 200) {
                    setDeptCheckOut(data.data);
                } else {
                }
            })
            .catch((error) => {
                // console.error(error);
            });
    };
    const getDetailsForCheckInOutByVendorId = (vendorId) => {
        axios
            .get("getDetailsForCheckInOutByVendorId/" + vendorId)
            .then((data) => {
                if (data.status === 200) {
                    const getData = data.data;
                    setDetailsForSecurityVendorId(getData);
                } else {
                    // window.location.href = "/error"
                }
            })
            .catch((error) => {
                console.error(error);

                // window.location.href = "/error"
            });
    };

    const getEmpDetailsForCheckInOutByShiftId = (shiftID) => {
        axios
            .get("getEmpDetailsForCheckInOutByShiftId/" + shiftID)
            .then((data) => {
                if (data.status === 200) {
                    const getData2 = data.data;
                    setDetailsForSecurityByShiftId(getData2);
                } else {
                }
            })
            .catch((error) => {
                // console.error(error);
            });
    };

    const onSelectVendor = (e) => {
        setVendorId(e.target.value);
        getDetailsForCheckInOutByVendorId(e.target.value);
    };

    const onSelectShift = (e) => {
        if (e.target.value == "") {
            setShowEmpDetails(false);
            setNewArray([]);
            setCheckOutLabourersByShift([]);
            return;
        }
        setShiftId(e.target.value);
        shiftIDRef.current = e.target.value;

        var currentdate = new Date();
        var transactionDate = formatDate(currentdate);
        const branchId = localStorage.getItem("branchId");

        // Get labourers for check-in
        axios
            .get("getLabourersNotCheckedInByShift/" + transactionDate + "/" + branchId + "/" + e.target.value)
            .then((data) => {
                if (data.status === 200) {
                    const getData = data.data;
                    setNewArray(getData);
                } else {
                    setNewArray([]);
                }
            })
            .catch((error) => {
                console.error(error);
                setNewArray([]);
            });

        // Get labourers for check-out
        getLabourersForCheckOutByShift(branchId, e.target.value);
    };
    const userName = localStorage.getItem("username");
    const handleSubmitCheckIn = async (e) => {
        e.preventDefault();

        if (isIndividualCheckInLoading) return; // Prevent multiple clicks

        setIsIndividualCheckInLoading(true);
        var currentdate = new Date();
        var datetime = formatDate(currentdate);
        var datetime1 = formatDateTime(currentdate);
        // Check if this labourer has a saved department assignment
        const savedAssignment = labourerDeptAssignments[dataListNew.labourId];
        const finalDeptId = savedAssignment ? savedAssignment.deptId : deptId;
        const finalDeptName = savedAssignment ? savedAssignment.deptName : deptName;

        const deptVendorDataAdd1 = {
            //       transactionId: transactionId,
            vendorId: vendorId, vendorCLTransactionId: clTransactionId, // vendorName: vendorName,
            transactionDate: datetime, subDepartmentId: subDeptId, departmentId: finalDeptId, labourId: labId.current, // labourName : laborerName,
            entryType: "CheckIn", shiftId: shiftId, shiftName: shiftName, createdBy: userName, createdDate: datetime1, // departmentName: deptName,
            // subDepartmentName: subDeptName,
            branchId: branchId,
        };
        console.log(dataListNew);

        try {
            const response = await axios.post("addSecurityTransactionDetails", deptVendorDataAdd1);
            if (response.status === 200) {
                setShowMsgI(true);
                setCheckCheckIn([...checkCheckIn, response]);
                setSecurityCheckIn(true);
                setCheckIn(checkIn + 1);
                // Refresh the data
                const branchId = localStorage.getItem("branchId");
                getSecurityTransactionDetailsByTransactionDate(branchId);
                getLabourersForCheckOut(branchId); // Refresh checkout data
                if (shiftIDRef.current !== "") {
                    getLabourersForCheckOutByShift(branchId, shiftIDRef.current); // Refresh checkout data by shift
                }
                toast.success("Successfully checked in labourer");
                //securityCheckAdd.TransactionId = 3;
                //           setSecurityCheckAdd(securityCheckAdd);
            }
        } catch (error) {
            console.error(error);
            toast.error("Check-in failed. Please try again.");
        }

        if(deptUpdated === true){
            try {
                await axios.put("updateVendorCLDetails", dataListNew);
            } catch (error) {
                console.error(error);
            }
        }

        setIsIndividualCheckInLoading(false);
    };

    const handleSubmitCheckOut = async (e) => {
        e.preventDefault();

        if (isIndividualCheckOutLoading) return; // Prevent multiple clicks

        setIsIndividualCheckOutLoading(true);
        var currentdate = new Date();
        var datetime = formatDate(currentdate);
        var datetime1 = formatDateTime(currentdate);
        const deptVendorDataAdd2 = {
            //transactionId: transactionId,
            vendorId: vendorId, // vendorName: vendorName,
            vendorCLTransactionId: clTransactionId,
            transactionDate: datetime,
            subDepartmentId: subDeptId,
            departmentId: deptId,
            labourId: labId.current, // labourName : laborerName,
            entryType: "CheckOut",
            shiftId: shiftId,
            shiftName: shiftName,
            createdBy: userName,
            createdDate: datetime, // departmentName: deptName,
            // subDepartmentName: subDeptName,
            branchId: branchId,
        };

        try {
            const response = await axios.post("addSecurityTransactionDetails", deptVendorDataAdd2);
            if (response.status === 200) {
                setShowMsgO(true);
                setCheckCheckOut([...checkCheckOut, response]);
                setSecurityCheckOut(true);
                setCheckOut(checkOut + 1);
                // Refresh the data
                const branchId = localStorage.getItem("branchId");
                getSecurityTransactionDetailsByTransactionDate(branchId);
                getLabourersForCheckOut(branchId); // Refresh checkout data
                if (shiftIDRef.current !== "") {
                    getLabourersForCheckOutByShift(branchId, shiftIDRef.current); // Refresh checkout data by shift
                }
                toast.success("Successfully checked out labourer");
                //           securityCheckAdd.TransactionId = data.data.TransactionId;
                //           setSecurityCheckAdd(securityCheckAdd);
            }
        } catch (error) {
            console.error(error);
            toast.error("Check-out failed. Please try again.");
        } finally {
            setIsIndividualCheckOutLoading(false);
        }
    };

    let showEmployeeDetails;

    if (showEmpDetails) {
        let dataShift = shiftData.filter(key => key.shiftId === dataListNew.shiftId);
        let shiftNameAfterClick = dataShift[0]?.shiftName;
        showEmployeeDetails = (<Card className="CardInt">
            {//detailsForSecurityByShiftId.map(dataList => (
                <div>
                    <div className=" employeeRow mt-3">
                        <Col md={{span: 6, offset: 6}} className="p-0 employeeImg">
                            <img src={dataListNew.labourImgUrl || user} className="userpic" alt=""/>
                        </Col>
                    </div>
                    <div>
                        {/* {
          labourerMasterDetails.map(empList => ( */}
                        <Col lg={12} className={"labourDetails"}>
                            <div className="mt-3">
                                <label className="labelEmpDetStyl">Name :</label>
                                <p className="pEmpDetStyl">{dataListNew.labourerName}</p>
                            </div>
                            <div className="mt-1">
                                <label className="labelEmpDetStyl">Vendor :</label>
                                <p className="pEmpDetStyl">{dataListNew.vendorName}</p>
                            </div>
                            <div className="mt-1">
                                <label className="labelEmpDetStyl">Aadhaar No :</label>
                                <p className="pEmpDetStyl">{dataListNew.adhaarNo}</p>
                            </div>
                            <div className="mt-1">
                                <label className="labelEmpDetStyl">Shift :</label>
                                <p className="pEmpDetStyl">{shiftNameAfterClick}</p>
                            </div>
                            <div className="mt-1">
                                <div>
                                    <label className="labelEmpDetStyl">Department :</label>
                                    {securityCheckIn === false && (<FontAwesomeIcon icon={faPen} className={"floatInlineEnd"} onClick={() => handleDeptEditClick(dataListNew.labourId)}/>)}
                                </div>
                                {showDeptDrop === true && editingLabourId === dataListNew.labourId && <Form.Select
                                    aria-label="Default select example"
                                    className="info1"
                                    onChange={(e) => editLabourDept(e)}
                                    value={tempDeptId}
                                >
                                    <option value="">Select Department</option>
                                    {deptDrop.map((dept) => (<option
                                        key={dept.departmentId}
                                        value={dept.departmentId}
                                        id= {dept.departmentName}
                                    >
                                        {dept.departmentName}
                                    </option>))}
                                </Form.Select>}
                                {showDeptDrop === false &&<p className="pEmpDetStyl">{dataListNew.deptName}</p>}
                            </div>
                            <div className="mt-1 mb-2">
                                <label className="labelEmpDetStyl">Sub-Department :</label>
                                <p className="pEmpDetStyl">{dataListNew.subDeptName}</p>
                            </div>
                            <div className=" mb-2 floatRight">
                                {showDeptDrop === true && editingLabourId === dataListNew.labourId &&
                                    <Button className={"btn btn-primary securitySubmit"} type="submit" onClick={(e) => saveLabourDeptAndSubD(e)} disabled={!deptUpdated}>Submit</Button>
                                }
                            </div>
                        </Col>
                    </div>
                </div>}
            {/*           ))} */}
        </Card>);
    }

    let showEmployeeDetails1;
    if (showEmpDetails) {
        let dataShift = shiftData.filter(key => key.shiftId === dataListNew.shiftId);
        let shiftNameAfterClick = dataShift[0]?.shiftName;
        showEmployeeDetails1 = (<Card className="CardInt">
            {//detailsForSecurityByShiftId.map(dataList => (
                <div>
                    <div className=" employeeRow mt-3">
                        <Col md={{span: 6, offset: 6}} className="p-0 employeeImg">
                            <img src={dataListNew.labourImgUrl || user} className="userpic" alt=""/>
                        </Col>
                    </div>
                    <div>
                        {/* {
          labourerMasterDetails.map(empList => ( */}
                        <Col lg={12} className={"labourDetails"}>
                            <div className="mt-3">
                                <label className="labelEmpDetStyl">Name :</label>
                                <p className="pEmpDetStyl">{dataListNew.labourerName}</p>
                            </div>
                            <div className="mt-1">
                                <label className="labelEmpDetStyl">Vendor :</label>
                                <p className="pEmpDetStyl">{dataListNew.vendorName}</p>
                            </div>
                            <div className="mt-1">
                                <label className="labelEmpDetStyl">Aadhaar No :</label>
                                <p className="pEmpDetStyl">{dataListNew.adhaarNo}</p>
                            </div>
                            <div className="mt-1">
                                <label className="labelEmpDetStyl">Shift :</label>
                                <p className="pEmpDetStyl">{shiftNameAfterClick}</p>
                            </div>
                            <div className="mt-1">
                                <div>
                                    <label className="labelEmpDetStyl">Department :</label>
                                    {/*<FontAwesomeIcon icon={faPen} className={"floatInlineEnd"} onClick={() => setShowDeptDrop(!showDeptDrop)}/>*/}
                                </div>
                                <p className="pEmpDetStyl">{dataListNew.deptName}</p>
                            </div>
                            <div className="mt-1 mb-2">
                                <label className="labelEmpDetStyl">Sub-Department :</label>
                                <p className="pEmpDetStyl">{dataListNew.subDeptName}</p>
                            </div>
                        </Col>
                    </div>
                </div>}
            {/*           ))} */}
        </Card>);
    }

    return (<div>
        <Container fluid className="px-0">
            <div className="mt-1 mb-2">
                <h5 className="priColor mb-0">Security</h5>
            </div>
            <div data-aos="zoom-in-right" data-aos-duration="550">
                <Card className="cardStyl">
                        <div>
                            <Row>
                                <Col
                                    className={"badgeClass1"}
                                    md={6}
                                    sm={6}
                                    xs={6}
                                    xl={6}
                                    lg={6}
                                >
                                    <Card className="counter-block">
                                        <Row>
                                            <Col md={4} sm={12} xl={4} lg={4}>
                                                <FiLogIn className="icon-dim"/>
                                            </Col>
                                            <Col md={8} sm={12} xl={8} lg={8}>
                                                {/*                         <div class="col-lg-6 col-md-6"> */}
                                                {/* <i class="FiLogIn"></i> */}
                                                <p className="counter-block-p">
                                                    No. Of Labourers Checked-In
                                                </p>
                                                { checkIn !== '' &&
                                                    <p className="count-p">{checkIn}</p>
                                                }

                                                {checkIn === "" && <p className="count-p"><Skeleton /></p>}

                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                                <Col
                                    className={"badgeClass2"}
                                    md={6}
                                    sm={6}
                                    xs={6}
                                    xl={6}
                                    lg={6}
                                >
                                    <Card className="counter-block">
                                        <Row>
                                            <Col md={4} sm={12} xl={4} lg={4}>
                                                <FiLogOut className="icon-dim"/>
                                            </Col>
                                            <Col md={8} sm={12} xl={8} lg={8}>
                                                {/*                         <div class="col-lg-6 col-md-6"> */}
                                                {/* <i class="FiLogIn"></i> */}
                                                <p className="counter-block-p">
                                                    No. Of Labourers Checked-Out
                                                </p>
                                                {/*                                           <p></p> */}
                                                <p className="count-p">{checkOut}</p>
                                                {/*                         </div> */}
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>
                        </div>

                        {/*                   <Form.Select
                    onChange={e => onSelectVendor(e)}
                  // value={vendorMasterData}
                  >
                    <option value="">Select Vendor</option>
                    {
                      vendorMasterData.map(vendor => (
                        <option key={vendor.id} value={vendor.id}>
                          {vendor.vendorName}
                        </option>
                      ))}
                  </Form.Select>*/}
                        {/*                 </Col> */}
                        {/* <Col md={4} sm={12} xl={4} lg={4} className='displayflex'>
                        <Form.Select aria-label="Default select example"
                          {...register("vendor", { required: true })}>
                          <option>Vendor List</option>
                          <option value="1">One</option>
                          <option value="2">Two</option>
                          <option value="3">Three</option>
                        </Form.Select>
                        {errors.vendor && <p className='validationMsg'>Vendor is Required</p>}
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;(Or)</span>
                      </Col> */}

                        {/*                 <Col md={3} sm={3} xl={3} lg={3}> */}
                        {/*                   <Row> */}
                        {/*                     <Col> */}
                        {/*                       <Form.Control type="text" placeholder="Search by Emp Id or Mob no" /> */}
                        {/* <Col lg={2}>
                  <Col md={2} sm={2} xl={2} lg={2}>

                    <Button className='btnwidth btnShadow' variant="light">
                      <IoIosAdd /> Add Filter
                    </Button>
                  </Col>
                  <Col md={2} sm={2} xl={2} lg={2}>
                  </Col> */}
                        {/*                 <Col lg={2}>
                  <Button className='btnwidth btnShadow'>Search</Button>
                </Col>*/}
                        <div>
                            <Card className=" cardCheckin1">
                                <Row className="m-2">
                                    {/* <div>
                                    <Stepper
                                    steps=
                                    {[
                                            { label: 'Security In'},
                                            { label: 'Department In' },
                                            { label: 'Department Out' },
                                            { label: 'Security Out'}
                                    ]}
                                    activeStep={statusCount}
                                    styleConfig={stepStyleConfig}
                                    />
                                    </div> */}
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Form>
                                            <div>
                                                <h6>Check In</h6>
                                            </div>
                                            <Card>
                                                <Row className=" m-3">
                                                    <Col lg={12} md={12} sm={12} xs={12}>
                                                        <Row>
                                                            <Col md={6} sm={12} xl={6} lg={6}>
                                                                {/*<Row className={"mb-2"}>*/}
                                                                {/*    <Form.Select*/}
                                                                {/*        aria-label="Default select example"*/}
                                                                {/*        className="info1"*/}
                                                                {/*        onChange={(e) => onSelectManPowerType(e)}*/}
                                                                {/*        // value={shiftId}*/}
                                                                {/*    >*/}
                                                                {/*        <option value="">Select Shift</option>*/}
                                                                {/*        {manpowerType.map((manpowerType) => (<option*/}
                                                                {/*            key={manpowerType.key}*/}
                                                                {/*            value={manpowerType.value}*/}
                                                                {/*        >*/}
                                                                {/*            {manpowerType.value}*/}
                                                                {/*        </option>))}*/}

                                                                {/*    </Form.Select>*/}
                                                                {/*    /!* {errors.shift && <p className='validationMsg'>Shift is Required</p>} *!/*/}
                                                                {/*</Row>*/}

                                                                <Row>
                                                                    <Form.Select
                                                                        aria-label="Default select example"
                                                                        className="info1"
                                                                        onChange={(e) => onSelectShift(e)}
                                                                        // disabled={showShift}
                                                                    >
                                                                        <option value="">Select Shift</option>
                                                                        {shiftData.map((shift) => (<option
                                                                            key={shift.shiftId}
                                                                            value={shift.shiftId}
                                                                        >
                                                                            {shift.shiftName}
                                                                        </option>))}

                                                                        {/*                                 value={detailsForSecurityVendorId} */}
                                                                        {/*                                 {...register("shift", { required: true })} */}
                                                                        {/* > */}
                                                                        {/*                                  <option>Select Shift</option> */}
                                                                        {/*                                  { */}
                                                                        {/*                                         <option value={data.shiftId}> */}
                                                                        {/*                                                 {data.shiftName} */}
                                                                        {/*                                       </option>} */}
                                                                        {/* detailsForSecurityVendorId.map(data1 => (
                                      <option value={data1.shiftId}>
                                        {data1.shiftName}
                                      </option>
                                      // <option value="2">Vendor-2</option>
                                      // <option value="3">Vendor-3</option>
                                    ))} */}
                                                                    </Form.Select>
                                                                    {/* {errors.shift && <p className='validationMsg'>Shift is Required</p>} */}
                                                                </Row>

                                                                <Row className=" mt-2">
                                                                    <Form.Control
                                                                        type="text"
                                                                        className="info1"
                                                                        placeholder="Select Emp"
                                                                        {...register("selectempci", {
                                                                            required: true,
                                                                        })}
                                                                    />
                                                                </Row>
                                                                <Row>
                                                                    {shiftIDRef.current == "" && renderLabourListCheckIn(masterLabourerDetailsByTransactionDate)}
                                                                    {errors.selectempci && (
                                                                        <p className="validationMsg">
                                                                            Selecting employee is Required
                                                                        </p>)}
                                                                </Row>
                                                                <Row>
                                                                    {shiftIDRef.current != "" && renderLabourListCheckIn(newArray)}
                                                                    {errors.selectempci && (
                                                                        <p className="validationMsg">
                                                                            Selecting employee is Required
                                                                        </p>)}
                                                                </Row>
                                                            </Col>

                                                            <Col
                                                                className={"employeeCard"}
                                                                md={6}
                                                                sm={12}
                                                                xl={6}
                                                                lg={6}
                                                            >
                                                                {showEmployeeDetails}
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <div className="buttonProceedDiv">
                                                        <div className="container">
                                                            <div className="row p-0">
                                                                <div className="text-left p-0">
                                                                    {/*                                   {checkCheckIn.length} */}
                                                                    {securityCheckIn === false && (
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-success float-end mx-2"
                                                                            onClick={(e) => handleShow(e)}
                                                                            disabled={isIndividualCheckInLoading}
                                                                        >
                                                                            {isIndividualCheckInLoading ? "Processing..." : "Check In"}
                                                                        </button>)}

                                                                    {securityCheckIn === true && (
                                                                        <p className="error-msg-p">
                                                                            Labour already checked-in.
                                                                        </p>)}
                                                                    {/* <button type="button" className="btn btn-reject float-end">Check In</button> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Row>
                                            </Card>
                                        </Form>
                                    </Col>

                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        {/* <Form> */}
                                        <Form>
                                            <div>
                                                <h6>Check Out</h6>
                                            </div>
                                            <Card>
                                                <Row className=" m-3">
                                                    <Col lg={12} md={12} sm={12} xs={12}>
                                                        <Row>
                                                            <Col md={6} sm={12} xl={6} lg={6}>
                                                                <Row>
                                                                    <Form.Select
                                                                        aria-label="Default select example"
                                                                        className="info1"
                                                                        onChange={(e) => onSelectShift(e)}
                                                                        value={shiftId}
                                                                    >
                                                                        <option value="">Select Shift</option>
                                                                        {shiftData.map((shift) => (<option
                                                                            key={shift.shiftId}
                                                                            value={shift.shiftId}
                                                                        >
                                                                            {shift.shiftName}
                                                                        </option>))}
                                                                        {/*                                       // <option value="2">Vendor-2</option> */}
                                                                        {/*                                       // <option value="3">Vendor-3</option> */}
                                                                        {/*                                     ))} */}
                                                                    </Form.Select>
                                                                    {/* {errors.shift && <p className='validationMsg'>Shift is Required</p>} */}
                                                                </Row>
                                                                <Row className=" mt-3">
                                                                    <Form.Control
                                                                        type="text"
                                                                        className="info1"
                                                                        placeholder="Select Emp"
                                                                        {...register("selectempci", {
                                                                            required: true,
                                                                        })}
                                                                    />
                                                                </Row>
                                                                <Row>
                                                                    {shiftIDRef.current == "" && renderLabourListCheckOut(checkOutLabourers)}
                                                                    {errors.selectempci && (
                                                                        <p className="validationMsg">
                                                                            Selecting employee is Required
                                                                        </p>)}
                                                                </Row>
                                                                <Row>
                                                                    {shiftIDRef.current != "" && renderLabourListCheckOut(checkOutLabourersByShift)}
                                                                    {errors.selectempci && (
                                                                        <p className="validationMsg">
                                                                            Selecting employee is Required
                                                                        </p>)}
                                                                </Row>
                                                            </Col>

                                                            <Col
                                                                className={"employeeCard"}
                                                                md={6}
                                                                sm={12}
                                                                xl={6}
                                                                lg={6}
                                                            >
                                                                {showEmployeeDetails1}
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <div className="buttonProceedDiv">
                                                        <div className="container">
                                                            <div className="row p-0">
                                                                <div className="text-left p-0">
                                                                    {securityCheckOut === false && deptartmentCheckOut === true && (
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-success float-end mx-2"
                                                                            onClick={(e) => checkOutBtn(e)}
                                                                            disabled={isIndividualCheckOutLoading}
                                                                        >
                                                                            {isIndividualCheckOutLoading ? "Processing..." : "Check Out"}
                                                                        </button>)}
                                                                    {deptartmentCheckOut === false && (
                                                                        <p className="error-msg-p">
                                                                            Labour's Department Check-Out pending.
                                                                        </p>)}
                                                                    {securityCheckOut === true && (
                                                                        <p className="error-msg-p">
                                                                            Labour already Checked-Out.
                                                                        </p>)}
                                                                    {/* <button type="button" className="btn btn-reject float-end">Proceed</button> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Row>
                                            </Card>
                                        </Form>
                                    </Col>
                                </Row>
                            </Card>
                        </div>
                    </Card>
                </div>
        </Container>
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header className="modal-header">
                {showCO == "" && <Modal.Title>Confirm Check-In</Modal.Title>}
                {showCO != "" && <Modal.Title>Confirm Check-Out</Modal.Title>}
            </Modal.Header>
            {showMsgI == "" && showCO == "" && (<Modal.Body>Please click on "Check In" to Check-In.</Modal.Body>)}
            {showMsgO == "" && showCO != "" && (<Modal.Body>Please click on "Check Out" to Check-Out.</Modal.Body>)}
            {showMsgI != "" && showCO == "" && (<Modal.Body>
                <img src={CheckInimg} className="check-in-img" alt=""/> <br></br>
                <h5>Check In Done Successfully !!</h5>
            </Modal.Body>)}
            {showMsgO != "" && showCO != "" && (<Modal.Body>
                <img src={CheckInimg} className="check-in-img" alt=""/> <br></br>
                <h5>Check Out Done Successfully !!</h5>
            </Modal.Body>)}
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                {showMsgI == "" && showCO == "" && (<Button type="button" onClick={(e) => handleSubmitCheckIn(e)} disabled={isIndividualCheckInLoading}>
                    {isIndividualCheckInLoading ? "Processing..." : "Check In"}
                </Button>)}
                {showMsgO == "" && showCO != "" && (<Button type="button" onClick={(e) => handleSubmitCheckOut(e)} disabled={isIndividualCheckOutLoading}>
                    {isIndividualCheckOutLoading ? "Processing..." : "Check Out"}
                </Button>)}
            </Modal.Footer>
        </Modal>
        {/*<ToastContainer*/}
        {/*    position="top-right"*/}
        {/*    autoClose={3000}*/}
        {/*    hideProgressBar={false}*/}
        {/*    newestOnTop={false}*/}
        {/*    closeOnClick*/}
        {/*    rtl={false}*/}
        {/*    pauseOnFocusLoss*/}
        {/*    draggable*/}
        {/*    pauseOnHover*/}
        {/*/>*/}
    </div>);
}

export default Security;
